import React from "react";
import { Link } from "react-router-dom";
import "../styles/components/hero.css";

function Hero() {
    return (
        <section className="hero">
            <div className="container hero__layout">
                <div className="hero__content">
                    <span className="hero__badge">Trusted Care, Staffing & Specialist Support</span>
                    <h1>Supporting People, Strengthening Services, Delivering Care with Confidence</h1>
                    <p>
                        We provide dependable staffing, mental health training, domiciliary care, children’s services, and secure transport with safety, dignity, and professionalism at the heart of everything we do.
                    </p>
                    <div className="hero__actions">
                        <Link to="/contact" className="btn btn--primary">Request a Consultation</Link>
                        <Link to="/services" className="btn btn--secondary">Explore Services</Link>
                    </div>

                    <div className="hero__stats">
                        <div className="hero__stat">
                            <strong>Responsive</strong>
                            <span>Fast, dependable support for urgent and planned service needs.</span>
                        </div>
                        <div className="hero__stat">
                            <strong>Person-Centred</strong>
                            <span>Services tailored to the needs of families, providers, and individuals.</span>
                        </div>
                    </div>
                </div>

                <div className="hero__panel">
                    <div className="hero__image-stack">
                        <img
                            className="hero__image hero__image--main"
                            src="https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?auto=format&fit=crop&w=900&q=80"
                            alt="Care professional supporting a client"
                        />
                        <img
                            className="hero__image hero__image--accent"
                            src="https://images.unsplash.com/photo-1576765608622-067973a79f53?auto=format&fit=crop&w=700&q=80"
                            alt="Healthcare support team"
                        />
                        <div className="hero__panel-card">
                            <p className="hero__panel-label">What we deliver</p>
                            <h3>Reliable support across care, recruitment, training, and transport.</h3>
                            <ul>
                                <li>Qualified staffing solutions</li>
                                <li>Specialist mental health training</li>
                                <li>Flexible home and live-in care</li>
                                <li>Children’s support services</li>
                                <li>Secure professional transport</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
